import * as constant from '../../constants'
/* export function changeStatus(sections, selectedSection) {

    sections.forEach(element => {
        if (element.subcaseNo === selectedSection.subcaseNo) {
            element.status = constant.APPROVE;
        }
    });
    return sections
} */

export function hasCompleted(caseData) {

    return ((caseData && caseData.hasOwnProperty('data')) && (caseData.data.status === constant.COMPLETED || caseData.data.status === constant.ONHOLD || caseData.data.status === constant.WITHDRAWN )) ? true : false;


}

export const activeTab = (param) => {
    let singleTab;
    singleTab = param.data[0];
    return singleTab;
}

export const sectionStatusIconClass = (status) => {
    switch (status) {
        case constant.PENDING:
            return "icon-in-progress";
        case constant.APPROVED:
            return "fa fa-thumbs-o-up";
        case constant.REJECTED:
            return "fa fa-thumbs-o-down";
        case constant.ASSIGNED:
            return "fa fa-user";
        case constant.SUBMITTED:
            return "text-muted fa fa-check";
        default:
            return "";
    }
}



export const sectionDetails = (sectionData, sectionNo) => {
    let section;
    sectionData.forEach(element => {
        if (element.computedSectionId === sectionNo) {
            section = element;
        }
    })
    return section
}

export const sectionDetailsUpload = (sectionData, caseData, file, sectionType) => {
    let requestBody;
    if (sectionType === constant.DATA || sectionType === constant.FINANCIAL || sectionType === constant.VIDEO_KYC) {
        /* caseData.data.tasks.forEach(element => {
            element.surveys.forEach(survey => {
                if (sectionData.sectionTemplateId === survey.sectionTemplateId) {
                    taskId = element.id
                }
            })
        }); */
        requestBody = {
            reportRequestCaseId: caseData.data.caseId,
            taskId: sectionData.taskId,
            counterPartyId: caseData.data.counterpartyId,
            sectionTemplateId: sectionData.sectionTemplateId,
            file: file,
        }
    }
    // If section type is null / predefined / international
    else if (!sectionType || sectionType === constant.PREDEFINED || sectionType === constant.INTERNATIONAL) {
        requestBody = {
            computedreportid: caseData.data.computedReportId,
            counterpartyid: caseData.data.counterpartyId,
            predefinedsectiontemplateid: sectionData.sectionTemplateId,
            sequenceid: sectionData.computedSectionId,
            file: file,
        }
    }
    return requestBody;
}

export const getSectionList = (preconfigData) => {
    let reqbody = [];
    reqbody = preconfigData.map(data => {
        return data.value
    }
    )
    return reqbody;
}
export const isPredefined = (sectionData) => {
    return (sectionData && sectionData.hasOwnProperty('sectionType') && sectionData.sectionType === constant.PREDEFINED ) ? true : false;
}

export const isVideoKYC = (sectionData) => {

    return (sectionData && sectionData.hasOwnProperty('sectionType') && sectionData.sectionType === constant.VIDEO_KYC) ? true : false;

}

export const isInternational = (sectionData) => {
    return (sectionData && sectionData.hasOwnProperty('sectionType') && sectionData.sectionType === constant.INTERNATIONAL ) ? true : false;
}

export const isDataSection = (sectionData) => {
    return (sectionData && sectionData.hasOwnProperty('sectionType') && sectionData.sectionType === constant.DATA) ? true : false;
}

export const isFinancialSection = (sectionData) => {
    return (sectionData && sectionData.hasOwnProperty('sectionType') && sectionData.sectionType === constant.FINANCIAL) ? true : false;
}

export const isSystemDefined = (sectionData) => {

    return (sectionData && sectionData.hasOwnProperty('sectionType') && sectionData.sectionType === constant.SYSTEMDEFINED) ? true : false;

}

export const isRejected = (sectionData) => {

    return (sectionData && sectionData.hasOwnProperty('taskStatus') && sectionData.taskStatus === constant.REJECTED) ? true : false;

}
export const isApproved = (sectionData) => {

    return (sectionData && sectionData.hasOwnProperty('taskStatus') && sectionData.taskStatus === constant.APPROVED) ? true : false;

}
export const isAssigned = (sectionData) => {

    return (sectionData && sectionData.hasOwnProperty('taskStatus') && sectionData.taskStatus === constant.ASSIGNED) ? true : false;

}

export const commentReadCountRequestBody = (taskListId) => {
    return {
        taskIdList: [taskListId]
    }
}

export const changeOrder = (newOrder) => {
    // let singleCase;
    /* for(let i=0;i<newOrder.length;i++)
    {
        newOrder[i].order=i;
    } */
    newOrder.forEach((element, index) => {
        element.order=index
    });
    return newOrder;
}


